export const BUILDER_ERROR = 'BUILDER_ERROR';
export const BUILDER_INFO = 'BUILDER_INFO';
export const BUILDER_REQUEST = 'BUILDER_REQUEST';
export const BUILDER_RESET = 'BUILDER_RESET';
export const BUILDER_SET = 'BUILDER_SET';
export const BUILDER_SET_CHAT = 'BUILDER_SET_CHAT';
export const BUILDER_SUCCESS = 'BUILDER_SUCCESS';
export const BUILDER_UPDATED = 'BUILDER_UPDATED';
